import apiClient from './apiClient';

/**
 * Country interface
 */
export interface Country {
  Country_ID: string;
  name: string;
  abbrev: string;
  city_count?: number;
}

/**
 * City interface
 */
export interface City {
  City_ID: string;
  name: string;
  Country_ID: string;
}

/**
 * Location API functions
 */
export const locationApi = {
  /**
   * Get all countries
   */
  getAllCountries: async (): Promise<Country[]> => {
    const response = await apiClient.get<Country[]>('/api/v2/web/countries');
    return response.data;
  },

  /**
   * Get a single country by ID
   */
  getCountryById: async (countryId: string): Promise<Country> => {
    const response = await apiClient.get<Country>(`/api/v2/web/countries/${countryId}`);
    return response.data;
  },

  /**
   * Create a new country
   */
  createCountry: async (countryData: { name: string; abbrev: string }): Promise<Country> => {
    const response = await apiClient.post<Country>('/api/v2/web/countries', countryData);
    return response.data;
  },

  /**
   * Update a country
   */
  updateCountry: async (countryId: string, countryData: { name: string; abbrev: string }): Promise<Country> => {
    const response = await apiClient.put<Country>(`/api/v2/web/countries/${countryId}`, countryData);
    return response.data;
  },

  /**
   * Delete a country
   */
  deleteCountry: async (countryId: string) => {
    const response = await apiClient.delete(`/api/v2/web/countries/${countryId}`);
    return response.data;
  },

  /**
   * Get all cities
   */
  getAllCities: async (countryId?: string): Promise<City[]> => {
    const url = countryId 
      ? `/api/v2/web/cities?country_id=${countryId}` 
      : '/api/v2/web/cities';
    const response = await apiClient.get<City[]>(url);
    return response.data;
  },

  /**
   * Get a single city by ID
   */
  getCityById: async (cityId: string): Promise<City> => {
    const response = await apiClient.get<City>(`/api/v2/web/cities/${cityId}`);
    return response.data;
  },

  /**
   * Create a new city
   */
  createCity: async (cityData: { name: string; Country_ID: string }): Promise<City> => {
    const response = await apiClient.post<City>('/api/v2/web/cities', cityData);
    return response.data;
  },

  /**
   * Update a city
   */
  updateCity: async (cityId: string, cityData: { name: string; Country_ID: string }): Promise<City> => {
    const response = await apiClient.put<City>(`/api/v2/web/cities/${cityId}`, cityData);
    return response.data;
  },

  /**
   * Delete a city
   */
  deleteCity: async (cityId: string) => {
    const response = await apiClient.delete(`/api/v2/web/cities/${cityId}`);
    return response.data;
  }
};
